import React from 'react';
import { Link } from 'react-router-dom';
import SeoHead from '../components/SeoHead';

export default function NotFoundPage() {
  return (
    <>
      <SeoHead
        title="404 – Siden blev ikke fundet – Ibjerget"
        description="Siden du leder efter findes desværre ikke på Ibjerget."
      />

      <section className="min-h-[80vh] flex items-center justify-center py-28 px-4 bg-[#FAF5F9]">
        <div className="max-w-xl mx-auto text-center bg-white rounded-3xl p-8 sm:p-12 border border-[#EDD5E8] shadow-sm space-y-6">
          <div className="w-16 h-16 mx-auto rounded-full bg-[#F0D9EB] text-[#D9238C] flex items-center justify-center text-2xl">
            <i className="fa-solid fa-compass" aria-hidden="true"></i>
          </div>

          <span className="text-xs font-semibold uppercase tracking-widest text-[#D9238C] block">
            Fejl 404
          </span>

          <h1 className="font-serif text-3xl sm:text-4xl font-semibold text-[#1f142e]">
            Siden blev ikke fundet
          </h1>

          <p className="text-sm text-[#4E3568] leading-relaxed">
            Vi kunne desværre ikke finde den side, du ledte efter. Måske er siden flyttet, eller linket er udløbet.
          </p>

          <div className="pt-4 grid grid-cols-1 sm:grid-cols-2 gap-3 text-left">
            <Link
              to="/"
              className="p-3.5 rounded-xl bg-[#FAF5F9] hover:bg-[#F0D9EB] border border-[#EDD5E8] text-xs font-medium text-[#1f142e] flex items-center gap-2 transition-colors"
            >
              <i className="fa-solid fa-house text-[#D9238C]"></i>
              <span>Gå til Forsiden</span>
            </Link>

            <Link
              to="/kropsterapi"
              className="p-3.5 rounded-xl bg-[#FAF5F9] hover:bg-[#F0D9EB] border border-[#EDD5E8] text-xs font-medium text-[#1f142e] flex items-center gap-2 transition-colors"
            >
              <i className="fa-solid fa-hand-holding-heart text-[#D9238C]"></i>
              <span>Læs om Kropsterapi</span>
            </Link>

            <Link
              to="/tarotterapi"
              className="p-3.5 rounded-xl bg-[#FAF5F9] hover:bg-[#F0D9EB] border border-[#EDD5E8] text-xs font-medium text-[#1f142e] flex items-center gap-2 transition-colors"
            >
              <i className="fa-solid fa-cards-blank text-[#D9238C]"></i>
              <span>Læs om Tarotterapi</span>
            </Link>

            <Link
              to="/kontakt"
              className="p-3.5 rounded-xl bg-[#FAF5F9] hover:bg-[#F0D9EB] border border-[#EDD5E8] text-xs font-medium text-[#1f142e] flex items-center gap-2 transition-colors"
            >
              <i className="fa-solid fa-envelope text-[#D9238C]"></i>
              <span>Kontakt Ibjerget</span>
            </Link>
          </div>
        </div>
      </section>
    </>
  );
}
